// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"PostCard_cardWrapper__Qt45q","card":"PostCard_card__Us4AS","title":"PostCard_title__mL2AN","btn":"PostCard_btn__pb1FQ","iconWrapper":"PostCard_iconWrapper__RAJ04"};